/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gold_Flat_Falcon_PlayInputs */

const en_gold_flat_falcon_play = /** @type {(inputs: Gold_Flat_Falcon_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const de_gold_flat_falcon_play = /** @type {(inputs: Gold_Flat_Falcon_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossen`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Gold_Flat_Falcon_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gold_flat_falcon_play = /** @type {((inputs?: Gold_Flat_Falcon_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gold_Flat_Falcon_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gold_flat_falcon_play(inputs)
	return de_gold_flat_falcon_play(inputs)
});